// @flow
import client from '../../client'
import { config } from '../../config'
import prebookSearchTripBuilder from './builders/prebookSearchTrip'
import ondemandSearchTripBuilder from './builders/ondemandSearchTrip'
import format from '../../utils/format'

// Types
import type { Trip } from '../../models/trip'
import type {
  OndemandSearchResponse,
  PrebookSearchResponse,
} from '../../api_types'

export type Options = {
  id: string,
  session_id: string,
  ondemand?: boolean,
  currency?: string,
}

// Constants
export const PREBOOK_TRIP_GET_ENDPOINT = '/search/{0}/{1}/'
export const ONDEMAND_TRIP_GET_ENDPOINT = '/ondemand/search/{0}/{1}/'

// Utils
const getPrebookTrip = (data: Options): Promise<Trip> => {
  const { session_id, id, ...rest } = data || {}
  const endpoint = format(PREBOOK_TRIP_GET_ENDPOINT, session_id, id)

  return client
    .get(endpoint, { query: rest, baseUrl: config.BASE_URL_SEARCH })
    .then((response: PrebookSearchResponse) => {
      const trip = response.results[0]
      return prebookSearchTripBuilder(trip, response)
    })
}

const getOndemandTrip = (data: Options): Promise<Trip> => {
  const { ondemand, session_id, id, ...rest } = data || {}
  const endpoint = format(ONDEMAND_TRIP_GET_ENDPOINT, session_id, id)

  return client
    .get(endpoint, { query: rest })
    .then((response: OndemandSearchResponse) => {
      const ride = response.ride_types[0].rides[0]
      return ondemandSearchTripBuilder(ride, response)
    })
}

/**
 * Get a trip from an appropreate service
 * @param {Object} data Trip information
 * @param {string} data.id Trip ID
 * @param {string} data.session_id Session ID
 * @param {string} [data.currency] Currency
 * @return {Promise|Error} A resolved Promise with a Trip object or Rejected with an Error
 */
export const getTrip = (data: Options) =>
  data.ondemand ? getOndemandTrip(data) : getPrebookTrip(data)

export default getTrip
